(function () {
  const arreglo = [
    {
      anio_mes: "1900-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "1989-02",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-01",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 2,
      total: 3,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-01",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 40,
      total: 61,
      tasa_defuncion: 3.28,
      tasa_hospitalizacion: 3.28,
    },
    {
      anio_mes: "2018-02",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 6,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-02",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 40,
      total: 57,
      tasa_defuncion: 5.26,
      tasa_hospitalizacion: 5.26,
    },
    {
      anio_mes: "2018-03",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 4,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-03",
      demografia_edad: "JOVEN",
      defuncion: 4,
      hospitalizacion: 32,
      total: 53,
      tasa_defuncion: 7.55,
      tasa_hospitalizacion: 7.55,
    },
    {
      anio_mes: "2018-04",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 1,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-04",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 44,
      total: 66,
      tasa_defuncion: 1.52,
      tasa_hospitalizacion: 1.52,
    },
    {
      anio_mes: "2018-05",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 2,
      total: 3,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-05",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 43,
      total: 58,
      tasa_defuncion: 1.72,
      tasa_hospitalizacion: 1.72,
    },
    {
      anio_mes: "2018-06",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 1,
      total: 7,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-06",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 37,
      total: 54,
      tasa_defuncion: 5.56,
      tasa_hospitalizacion: 5.56,
    },
    {
      anio_mes: "2018-07",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 2,
      total: 8,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-07",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 41,
      total: 58,
      tasa_defuncion: 1.72,
      tasa_hospitalizacion: 1.72,
    },
    {
      anio_mes: "2018-07",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-08",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 5,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 42,
      total: 63,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-09",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 9,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 37,
      total: 52,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-09",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-10",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 5,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-10",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 26,
      total: 45,
      tasa_defuncion: 2.22,
      tasa_hospitalizacion: 2.22,
    },
    {
      anio_mes: "2018-11",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 4,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-11",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 40,
      total: 53,
      tasa_defuncion: 1.89,
      tasa_hospitalizacion: 1.89,
    },
    {
      anio_mes: "2018-12",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 3,
      total: 6,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2018-12",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 43,
      total: 58,
      tasa_defuncion: 1.72,
      tasa_hospitalizacion: 1.72,
    },
    {
      anio_mes: "2018-12",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-01",
      demografia_edad: "",
      defuncion: null,
      hospitalizacion: 1,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-01",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 2,
      total: 11,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-01",
      demografia_edad: "JOVEN",
      defuncion: 7,
      hospitalizacion: 61,
      total: 118,
      tasa_defuncion: 5.93,
      tasa_hospitalizacion: 5.93,
    },
    {
      anio_mes: "2019-02",
      demografia_edad: "",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-02",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 2,
      total: 6,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-02",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 61,
      total: 98,
      tasa_defuncion: 3.06,
      tasa_hospitalizacion: 3.06,
    },
    {
      anio_mes: "2019-02",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: 1,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-03",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 7,
      total: 14,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-03",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 56,
      total: 93,
      tasa_defuncion: 1.08,
      tasa_hospitalizacion: 1.08,
    },
    {
      anio_mes: "2019-04",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 3,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-04",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 63,
      total: 91,
      tasa_defuncion: 2.2,
      tasa_hospitalizacion: 2.2,
    },
    {
      anio_mes: "2019-05",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 2,
      total: 5,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-05",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 61,
      total: 86,
      tasa_defuncion: 2.33,
      tasa_hospitalizacion: 2.33,
    },
    {
      anio_mes: "2019-05",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-06",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 5,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-06",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 56,
      total: 80,
      tasa_defuncion: 3.75,
      tasa_hospitalizacion: 3.75,
    },
    {
      anio_mes: "2019-07",
      demografia_edad: "",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-07",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 50,
      total: 63,
      tasa_defuncion: 1.59,
      tasa_hospitalizacion: 1.59,
    },
    {
      anio_mes: "2019-08",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 4,
      total: 5,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-08",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 36,
      total: 54,
      tasa_defuncion: 3.7,
      tasa_hospitalizacion: 3.7,
    },
    {
      anio_mes: "2019-09",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 1,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 32,
      total: 46,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-10",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-10",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 35,
      total: 46,
      tasa_defuncion: 2.17,
      tasa_hospitalizacion: 2.17,
    },
    {
      anio_mes: "2019-11",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-11",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 26,
      total: 36,
      tasa_defuncion: 5.56,
      tasa_hospitalizacion: 5.56,
    },
    {
      anio_mes: "2019-12",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2019-12",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 24,
      total: 28,
      tasa_defuncion: 3.57,
      tasa_hospitalizacion: 3.57,
    },
    {
      anio_mes: "2020-01",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2020-01",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 42,
      total: 56,
      tasa_defuncion: 1.79,
      tasa_hospitalizacion: 1.79,
    },
    {
      anio_mes: "2020-02",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 3,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2020-02",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 68,
      total: 87,
      tasa_defuncion: 2.3,
      tasa_hospitalizacion: 2.3,
    },
    {
      anio_mes: "2020-03",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2020-03",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 38,
      total: 54,
      tasa_defuncion: 1.85,
      tasa_hospitalizacion: 1.85,
    },
    {
      anio_mes: "2020-03",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2020-04",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 4,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2020-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 19,
      total: 27,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2020-05",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 1,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2020-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 7,
      total: 9,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2020-05",
      demografia_edad: "MAYOR",
      defuncion: 1,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 100,
      tasa_hospitalizacion: 100,
    },
    {
      anio_mes: "2020-06",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
      total: 6,
      tasa_defuncion: 16.67,
      tasa_hospitalizacion: 16.67,
    },
    {
      anio_mes: "2020-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: null,
      total: 3,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2020-08",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
      total: 3,
      tasa_defuncion: 33.33,
      tasa_hospitalizacion: 33.33,
    },
    {
      anio_mes: "2020-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
      total: 4,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2020-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2020-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2021-02",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 100,
      tasa_hospitalizacion: 100,
    },
    {
      anio_mes: "2021-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2021-04",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 1,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2021-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: null,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2021-05",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 100,
      tasa_hospitalizacion: 100,
    },
    {
      anio_mes: "2021-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2021-07",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2021-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: null,
      total: 3,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2021-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2021-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2021-10",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2021-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2021-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2021-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
      total: 3,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2022-01",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2022-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2022-04",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2022-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
      total: 6,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2022-06",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2022-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
      total: 5,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2022-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: null,
      total: 4,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2022-08",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
      total: 5,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2022-09",
      demografia_edad: "ADULTO",
      defuncion: 1,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 100,
      tasa_hospitalizacion: 100,
    },
    {
      anio_mes: "2022-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
      total: 10,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2022-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 2,
      total: 10,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2022-11",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 3,
      total: 11,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2022-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 5,
      total: 11,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2023-01",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
      total: 7,
      tasa_defuncion: 14.29,
      tasa_hospitalizacion: 14.29,
    },
    {
      anio_mes: "2023-02",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 3,
      total: 5,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2023-02",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 1,
      total: 8,
      tasa_defuncion: 12.5,
      tasa_hospitalizacion: 12.5,
    },
    {
      anio_mes: "2023-03",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 1,
      total: 10,
      tasa_defuncion: 20,
      tasa_hospitalizacion: 20,
    },
    {
      anio_mes: "2023-04",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: null,
      total: 8,
      tasa_defuncion: 12.5,
      tasa_hospitalizacion: 12.5,
    },
    {
      anio_mes: "2023-05",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 2,
      total: 11,
      tasa_defuncion: 9.09,
      tasa_hospitalizacion: 9.09,
    },
    {
      anio_mes: "2023-06",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 4,
      total: 14,
      tasa_defuncion: 14.29,
      tasa_hospitalizacion: 14.29,
    },
    {
      anio_mes: "2023-07",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2023-07",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 6,
      total: 18,
      tasa_defuncion: 5.56,
      tasa_hospitalizacion: 5.56,
    },
    {
      anio_mes: "2023-08",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 8,
      total: 16,
      tasa_defuncion: 12.5,
      tasa_hospitalizacion: 12.5,
    },
    {
      anio_mes: "2023-09",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2023-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 4,
      total: 14,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2023-10",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 1,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2023-10",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 9,
      total: 18,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2023-11",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2023-11",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 11,
      total: 28,
      tasa_defuncion: 7.14,
      tasa_hospitalizacion: 7.14,
    },
    {
      anio_mes: "2023-11",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2023-12",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2023-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 7,
      total: 19,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-01",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 12,
      total: 21,
      tasa_defuncion: 9.52,
      tasa_hospitalizacion: 9.52,
    },
    {
      anio_mes: "2024-02",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-02",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 8,
      total: 16,
      tasa_defuncion: 6.25,
      tasa_hospitalizacion: 6.25,
    },
    {
      anio_mes: "2024-03",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-03",
      demografia_edad: "JOVEN",
      defuncion: 4,
      hospitalizacion: 11,
      total: 26,
      tasa_defuncion: 15.38,
      tasa_hospitalizacion: 15.38,
    },
    {
      anio_mes: "2024-03",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-04",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-04",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 20,
      total: 38,
      tasa_defuncion: 7.89,
      tasa_hospitalizacion: 7.89,
    },
    {
      anio_mes: "2024-05",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 2,
      total: 3,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-05",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 27,
      total: 38,
      tasa_defuncion: 5.26,
      tasa_hospitalizacion: 5.26,
    },
    {
      anio_mes: "2024-06",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 2,
      total: 7,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-06",
      demografia_edad: "JOVEN",
      defuncion: 4,
      hospitalizacion: 17,
      total: 33,
      tasa_defuncion: 12.12,
      tasa_hospitalizacion: 12.12,
    },
    {
      anio_mes: "2024-07",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 1,
      total: 12,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-07",
      demografia_edad: "JOVEN",
      defuncion: 5,
      hospitalizacion: 40,
      total: 62,
      tasa_defuncion: 8.06,
      tasa_hospitalizacion: 8.06,
    },
    {
      anio_mes: "2024-08",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 5,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-08",
      demografia_edad: "JOVEN",
      defuncion: 2,
      hospitalizacion: 32,
      total: 59,
      tasa_defuncion: 3.39,
      tasa_hospitalizacion: 3.39,
    },
    {
      anio_mes: "2024-09",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 8,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-09",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 28,
      total: 41,
      tasa_defuncion: 2.44,
      tasa_hospitalizacion: 2.44,
    },
    {
      anio_mes: "2024-10",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 9,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-10",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 26,
      total: 40,
      tasa_defuncion: 7.5,
      tasa_hospitalizacion: 7.5,
    },
    {
      anio_mes: "2024-11",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 15,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-11",
      demografia_edad: "JOVEN",
      defuncion: 1,
      hospitalizacion: 21,
      total: 37,
      tasa_defuncion: 2.7,
      tasa_hospitalizacion: 2.7,
    },
    {
      anio_mes: "2024-11",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-12",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 1,
      total: 9,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2024-12",
      demografia_edad: "JOVEN",
      defuncion: 6,
      hospitalizacion: 29,
      total: 47,
      tasa_defuncion: 12.77,
      tasa_hospitalizacion: 12.77,
    },
    {
      anio_mes: "2024-12",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-01",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 5,
      total: 54,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-01",
      demografia_edad: "JOVEN",
      defuncion: 21,
      hospitalizacion: 117,
      total: 309,
      tasa_defuncion: 6.8,
      tasa_hospitalizacion: 6.8,
    },
    {
      anio_mes: "2025-01",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: 1,
      total: 5,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-02",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 8,
      total: 130,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-02",
      demografia_edad: "JOVEN",
      defuncion: 22,
      hospitalizacion: 185,
      total: 606,
      tasa_defuncion: 3.63,
      tasa_hospitalizacion: 3.63,
    },
    {
      anio_mes: "2025-02",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: 2,
      total: 14,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-03",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 25,
      total: 316,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-03",
      demografia_edad: "JOVEN",
      defuncion: 18,
      hospitalizacion: 331,
      total: 989,
      tasa_defuncion: 1.82,
      tasa_hospitalizacion: 1.82,
    },
    {
      anio_mes: "2025-03",
      demografia_edad: "MAYOR",
      defuncion: 1,
      hospitalizacion: 3,
      total: 20,
      tasa_defuncion: 5,
      tasa_hospitalizacion: 5,
    },
    {
      anio_mes: "2025-04",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 24,
      total: 202,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-04",
      demografia_edad: "JOVEN",
      defuncion: 10,
      hospitalizacion: 190,
      total: 540,
      tasa_defuncion: 1.85,
      tasa_hospitalizacion: 1.85,
    },
    {
      anio_mes: "2025-04",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: 1,
      total: 15,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-05",
      demografia_edad: "ADULTO",
      defuncion: 1,
      hospitalizacion: 10,
      total: 125,
      tasa_defuncion: 0.8,
      tasa_hospitalizacion: 0.8,
    },
    {
      anio_mes: "2025-05",
      demografia_edad: "JOVEN",
      defuncion: 6,
      hospitalizacion: 123,
      total: 290,
      tasa_defuncion: 2.07,
      tasa_hospitalizacion: 2.07,
    },
    {
      anio_mes: "2025-05",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: 1,
      total: 13,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-06",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 8,
      total: 75,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-06",
      demografia_edad: "JOVEN",
      defuncion: 7,
      hospitalizacion: 100,
      total: 239,
      tasa_defuncion: 2.93,
      tasa_hospitalizacion: 2.93,
    },
    {
      anio_mes: "2025-06",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: null,
      total: 4,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-07",
      demografia_edad: "ADULTO",
      defuncion: 1,
      hospitalizacion: 1,
      total: 65,
      tasa_defuncion: 1.54,
      tasa_hospitalizacion: 1.54,
    },
    {
      anio_mes: "2025-07",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 73,
      total: 192,
      tasa_defuncion: 1.56,
      tasa_hospitalizacion: 1.56,
    },
    {
      anio_mes: "2025-07",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: null,
      total: 4,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-08",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 2,
      total: 36,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-08",
      demografia_edad: "JOVEN",
      defuncion: 3,
      hospitalizacion: 49,
      total: 125,
      tasa_defuncion: 2.4,
      tasa_hospitalizacion: 2.4,
    },
    {
      anio_mes: "2025-09",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 3,
      total: 18,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-09",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 30,
      total: 65,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-09",
      demografia_edad: "MAYOR",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-12",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: 1,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2025-12",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
      total: 2,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2026-01",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2026-03",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2026-05",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2026-06",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2026-07",
      demografia_edad: "JOVEN",
      defuncion: null,
      hospitalizacion: 1,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
    {
      anio_mes: "2026-09",
      demografia_edad: "ADULTO",
      defuncion: null,
      hospitalizacion: null,
      total: 1,
      tasa_defuncion: 0,
      tasa_hospitalizacion: 0,
    },
  ];
  Data.getDefuncion = function () {
    return arreglo;
  };
})();
